import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import '../App.css';
import Sidebar from '../componenteExtra/SidebarStaff';
import { GrupoContext } from '../GrupoContext';
import SessionManager from '../componenteExtra/SessionManager';

const AsignacionesCompletadasStaff = () => {
    const { grupo: staffName } = useContext(GrupoContext);
    const [actividades, setActividades] = useState([]);
    const [nombreGet, setNombreGet] = useState('');

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        // Restaurar el estado de nombreGet desde localStorage
        const savedNombreGet = localStorage.getItem('nombre_get');
        if (savedNombreGet) {
            setNombreGet(savedNombreGet);
        }

        // Cargar actividades si el nombre está disponible
        if (savedNombreGet) {
            fetchActividadesCompletadas(savedNombreGet);
        }
    }, []);

    useEffect(() => {
        // Guardar el nombre en localStorage si cambia
        if (nombreGet) {
            localStorage.setItem('nombre_get', nombreGet);
        }
    }, [nombreGet]);

    const fetchActividadesCompletadas = async (nombre) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/completed_activities/${nombre}`, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            setActividades(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };    

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Actividades completadas - {nombreGet}</h1>
                    <h2>Total Actividades: {actividades.length}</h2>
                    <table className="activities-table">
                        <thead>
                            <tr>
                                <th>Código de Proyecto</th>
                                <th>Nombre de Proyecto</th>
                                <th>Razón Social</th>
                                <th>Filial</th>
                                <th>Socio de auditoría</th>
                                <th>Jefe de Grupo</th>
                                <th>Subrogante</th>
                                <th>Rubro GET</th>
                                <th>Nombre Actividad GET</th>
                                <th>Staff Asignado</th>
                                <th>Horas GET</th>
                                <th>Horas Estándar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actividades.map((actividad) => (
                                <tr key={actividad.id}>
                                    <td>{actividad.codigo_proyecto}</td>
                                    <td>{actividad.nombre_proyecto}</td>
                                    <td>{actividad.razon_social}</td>
                                    <td>{actividad.filial}</td>
                                    <td>{actividad.encargado_auditoria}</td>
                                    <td>{actividad.jefe_grupo}</td>
                                    <td>{actividad.subrogante}</td>
                                    <td>{actividad.rubro_get}</td>
                                    <td>{actividad.nombre_actividad_get}</td>
                                    <td>{actividad.staff_asignado}</td>
                                    <td>{actividad.horas_get}</td>
                                    <td>{actividad.horas_estandar}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AsignacionesCompletadasStaff;
